/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Missing_StreamInputs */

const vi_grower_area_camera_missing_stream = /** @type {(inputs: Grower_Area_Camera_Missing_StreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiếu token stream`)
};

/**

* @param {Grower_Area_Camera_Missing_StreamInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_missing_stream = /** @type {((inputs?: Grower_Area_Camera_Missing_StreamInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Missing_StreamInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_missing_stream(inputs)
});